function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "graphcool",
  d: "M81.833,32.374c-4.767-2.684-10.754.817-11.712,1.421L49.549,45.464a8.032,8.032,0,1,0,2.908,4.89L72.969,38.709l.131-.076c1.348-.855,4.476-2.129,5.938-1.3,1.054.6,1.655,2.586,1.7,5.513h-.025V68.573a6.738,6.738,0,0,1-3.36,5.824L47.861,91.434a6.744,6.744,0,0,1-6.722,0L11.646,74.4a6.738,6.738,0,0,1-3.36-5.824V34.514a6.73,6.73,0,0,1,3.36-5.821l26.692-15.4a8.018,8.018,0,1,0-1.971-5.423L8.831,23.776a12.415,12.415,0,0,0-6.224,10.74V68.567a12.415,12.415,0,0,0,6.2,10.743L38.3,96.348a12.428,12.428,0,0,0,12.4,0L80.2,79.311a12.434,12.434,0,0,0,6.2-10.738V43.817h.019c.139-5.807-1.416-9.651-4.585-11.443Z",
  transform: "translate(-2.607 -0.003)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "graphcool-2",
  "data-name": "graphcool",
  d: "M38.338,13.289a8.018,8.018,0,1,0-1.971-5.423C38.287,13.1,36.4,7.989,38.338,13.289Z",
  transform: "translate(-2.607 -0.003)",
  fill: "#ac1ede"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "graphcool-3",
  "data-name": "graphcool",
  d: "M49.549,45.464a8.032,8.032,0,1,0,2.908,4.89C49.557,45.538,52.449,50.425,49.549,45.464Z",
  transform: "translate(-2.607 -0.003)",
  fill: "#ac1ede"
});

var SvgGicon = function SvgGicon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_37_2",
    "data-name": "Component 37 \\u2013 2",
    width: 83.82,
    height: 98.003,
    viewBox: "0 0 83.82 98.003",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGicon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/gicon.6b84b608.svg";
export { ForwardRef as ReactComponent };